import { render, staticRenderFns } from "./GroupListContextMenu.vue?vue&type=template&id=8901bf12&scoped=true&"
import script from "./GroupListContextMenu.vue?vue&type=script&lang=ts&"
export * from "./GroupListContextMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListContextMenu.vue?vue&type=style&index=0&id=8901bf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8901bf12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
